import { BrowserMultiFormatReader, Result } from '@zxing/library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Webcam from 'react-webcam';

const BarcodeScannerComponent = ({
  onUpdate
}: {
  onUpdate: (arg0: unknown, arg1?: Result) => void;
}): React.ReactElement =>
{
  const { t } = useTranslation();
  const webcamRef = React.useRef(null)
  const codeReader = React.useMemo(() => new BrowserMultiFormatReader(), [])
  const [useFallbackCamera, setUseFallbackCamera] = React.useState(false);
  const [cameraError, setCameraError] = React.useState<string | null>(null);

  const capture = React.useCallback(
    () =>
    {
      const imageSrc = (webcamRef?.current as any)?.getScreenshot()
      if(imageSrc)
      {
        codeReader.decodeFromImage(undefined, imageSrc).then(result =>
        {
          onUpdate(null, result)
        }).catch((err) =>
        {
          onUpdate(err)
        })
      }
    },
    [codeReader, onUpdate]
  )

  React.useEffect(() =>
  {
    const intervalId = window.setInterval(capture, 100);
    return () => window.clearInterval(intervalId);
  }, [capture]);

  const handleUserMedia = React.useCallback(() =>
  {
    setCameraError(null);
  }, []);

  const handleUserMediaError = React.useCallback(() =>
  {
    if(!useFallbackCamera)
    {
      setUseFallbackCamera(true);
      return;
    }

    setCameraError(t("partnerPortal.search.cameraUnavailable"));
  }, [t, useFallbackCamera]);

  return (
    <>
      <Webcam
        audio={false}
        forceScreenshotSourceSize={true}
        ref={webcamRef}
        screenshotFormat="image/png"
        onUserMedia={handleUserMedia}
        onUserMediaError={handleUserMediaError}
        videoConstraints={useFallbackCamera
          ? undefined
          : {
            facingMode: { ideal: 'environment' },
          }}
      />
      {cameraError ?
        <div style={{
          position: 'absolute',
          left: 16,
          right: 16,
          bottom: 16,
          padding: '10px 12px',
          borderRadius: 8,
          backgroundColor: 'rgba(0, 0, 0, 0.65)',
          color: '#ffffff',
          fontSize: 14,
          lineHeight: 1.3,
        }}>
          {cameraError}
        </div>
        : null}
    </>
  )
}
export default BarcodeScannerComponent
